import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { useRouter } from 'next/router';
import { TextareaAutosize, Button } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import { postRequest } from 'utils/api';
import { closeModal } from 'features/utilsSlice';
import { setGig } from 'features/gigsSlice';
import useModalOpen from 'hooks/useModalOpen';
import TransitionDialog from 'components/TransitionDialog';
import styles from 'styles/components/gigs/ReviewDialog.module.scss';

const useStyles = makeStyles(theme => ({
  paper: {
    height: 'fit-content',
    width: '90%',
    marginBottom: 'auto',
    marginTop: 100,
    borderRadius: 10,
  },

  paperFullScreenDialog: {
    [theme.breakpoints.up('md')]: {
      width: '50%',
      margin: '0 auto',
    },

    [theme.breakpoints.up('lg')]: {
      width: '35%',
    },
  },
}));

const RejectMilestoneNote = ({ milestone, gig }) => {
  const [message, setMessage] = useState('');
  const open = useModalOpen('Reject Note');
  const dispatch = useDispatch();
  const router = useRouter();
  const classes = useStyles();

  const handleClose = () => {
    dispatch(closeModal('Reject Note'));
    dispatch(closeModal('Reject'));
    dispatch(closeModal('Milestone'));
  };

  const rejectMilestone = () => {
    postRequest({
      endpoint: `milestones/${milestone.id}/reject`,
      data: { rejection_reason: message },
      successMessage: 'ToDo rejected.',
    }).then(response => {
      const milestones = gig.milestones.map(m => (m.id === milestone.id ? response.data : m));

      dispatch(setGig({ ...gig, milestones }));
      router.push(`/gigs/${milestone.gig_id}?tab=chat`, undefined, {
        shallow: true,
      });

      handleClose();
    });
  };

  return (
    <TransitionDialog
      open={open}
      handleClose={handleClose}
      paperProps={{ className: classes.paper }}
      dialogStyles={classes.paperFullScreenDialog}
      direction="up"
      desktopDirection="up"
      noCloseIcon
    >
      <div className={styles.rejectContainer}>
        <div style={{ padding: '0 15px 25px' }}>
          <div className={styles.title}>
            <h3>
              Please explain in detail why are you rejecting this milestone so the influencer can
              attempt to remedy the situation.
            </h3>
          </div>

          <TextareaAutosize
            onChange={e => setMessage(e.target.value)}
            minRows={8}
            maxRows={8}
            placeholder="I'm not happy with the picture as it doesn't show enough of the product. "
          />
        </div>

        <div className={styles.buttons}>
          <Button onClick={handleClose} color="primary" fullWidth>
            Cancel
          </Button>

          <Button
            disabled={!message}
            variant="contained"
            color="primary"
            fullWidth
            onClick={rejectMilestone}
          >
            Send
          </Button>
        </div>
      </div>
    </TransitionDialog>
  );
};

RejectMilestoneNote.propTypes = {
  milestone: PropTypes.object,
  gig: PropTypes.object,
};

RejectMilestoneNote.defaultProps = {
  milestone: {},
  gig: null,
};

export default RejectMilestoneNote;
